/* eslint-disable no-restricted-syntax */
import { PriceType } from 'tennders-common/enums/PriceType'
import { isArray, isNumber, isObject, isString, map } from 'lodash'
import moment from 'moment'

/* eslint-disable guard-for-in */
export function violationToErr(err) {
  const v = {}
  for (const i in err.violations) {
    v[err.violations[i].propertyPath] = err.violations[i].message
  }
  return v
}

export function cleanObject(obj) {
  const newObject = {}
  for (const key in obj) {
    if (obj[key] && typeof obj[key] === 'object') {
      newObject[key] = {}
    } else if (obj[key] && typeof obj[key] === 'string') {
      newObject[key] = ''
    } else {
      newObject[key] = null
    }
  }
  return newObject
}

export function isValidPhone(phoneStr) {
  return phoneStr && phoneStr.length === 10
}

export function dateToDMY(date) {
  let dd = date.getDate()
  let mm = date.getMonth() + 1 // January is 0!

  const yyyy = date.getFullYear()
  if (dd < 10) {
    dd = `0${dd}`
  }
  if (mm < 10) {
    mm = `0${mm}`
  }
  return `${dd}/${mm}/${yyyy}`
}

export function dateToStr(date) {
  return moment(date).format('DD/MM/YYYY HH:mm')
}

export function tsToDateString(ts) {
  const date = new Date(ts)
  return date.toLocaleDateString()
}

export function padTo2Digits(num) {
  return num.toString().padStart(2, '0')
}

export function datetimeTString(date) {
  const time = date.split('T')[1].split(':')
  return `${date.split('T')[0]} ${time[0]}:${time[1]}`
}

export function dayMonthHourString(date) {
  const time = date.split('T')[1].split(':')
  const dateString = date.split('T')[0].split('-')
  return `${dateString[2]}/${dateString[1]} ${time[0]}:${time[1]}`
}

export function fromDMYToDate(dateStr) {
  const dateParts = dateStr.split('/')
  return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
}

export function isValidDate(dateString) {
  // First check for the pattern
  if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
    return false
  }
  // Parse the date parts to integers
  const parts = dateString.split('/')
  const day = parseInt(parts[0], 10)
  const month = parseInt(parts[1], 10)
  const year = parseInt(parts[2], 10)
  // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) {
    return false
  }
  const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
  // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29
  }
  // Check the range of the day
  return day > 0 && day <= monthLength[month - 1]
}

export function httpBuildQuery(params) {
  const esc = encodeURIComponent
  return Object.keys(params)
    .map((k) => `${esc(k)}=${esc(params[k])}`)
    .join('&')
}

export function calculateDistance(latlngFirst, latlngSecond, next) {
  fetch(`https://route.ls.hereapi.com/routing/7.2/calculateroute.json?apiKey=4c2tsErxS7jLGvdo3tFhPl-RjmUy3x5ZiitG-7dQFVQ&waypoint0=geo!${latlngFirst.join(',')
  }&waypoint1=geo!${latlngSecond.join(',')}&routeattributes=wp,sm,sh,sc&mode=fastest;truck`)
    .then((response) => response.json())
    .then((data) => {
      next(data.response.route[0].summary)
    })
}

export function calculateEmptyKm(firstLocation, secondLocation, next) {
  fetch(`https://route.ls.hereapi.com/routing/7.2/calculateroute.json?apiKey=4c2tsErxS7jLGvdo3tFhPl-RjmUy3x5ZiitG-7dQFVQ&waypoint0=geo!${firstLocation.lat},${firstLocation.lng}&waypoint1=geo!${secondLocation.lat},${secondLocation.lng}&routeattributes=wp,sm,sh,sc&mode=fastest;truck`)
    .then((response) => response.json())
    .then((data) => {
      next(data.response.route[0].summary)
    })
    .catch((err) => {
      next({})
    })
}

export function calcCrowDistance(lat1, lon1, lat2, lon2) {
  // Converts numeric degrees to radians
  const toRad = (value) => (value * Math.PI) / 180
  const R = 6371 // km
  const dLat = toRad(lat2 - lat1)
  const dLon = toRad(lon2 - lon1)
  const rlat1 = toRad(lat1)
  const rlat2 = toRad(lat2)
  const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(rlat1) * Math.cos(rlat2)
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
  const d = R * c
  return d
}

export function calculateRouteDistance(routes, next) {
  let url = 'https://route.ls.hereapi.com/routing/7.2/calculateroute.json?apiKey=4c2tsErxS7jLGvdo3tFhPl-RjmUy3x5ZiitG-7dQFVQ&'
  let routeCount = 0
  const routeList = []
  for (let i = 0; i < routes.length; i += 1) {
    if (routes[i]?.location && routes[i]?.location.latitude) {
      routeCount += 1
      routeList.push([routes[i].location.latitude, routes[i].location.longitude].join(','))
      url += `wayPoint${i}=geo!${[routes[i].location.latitude, routes[i].location.longitude].join(',')}&`
    } else if (routes[i]?.location && routes[i]?.location.lat) {
      routeCount += 1
      routeList.push([routes[i].location.lat, routes[i].location.lng].join(','))
      url += `wayPoint${i}=geo!${[routes[i].location.lat, routes[i].location.lng].join(',')}&`
    }
  }
  if (routeCount < 2) {
    return next(false)
  }
  fetch(`${url}routeattributes=wp,sm,sh,sc&mode=fastest;truck`)
    .then((response) => response.json())
    .then((data) => {
      const mapUrl = `${'https://image.maps.ls.hereapi.com/mia/1.6/route'
                                    + '?apiKey=4c2tsErxS7jLGvdo3tFhPl-RjmUy3x5ZiitG-7dQFVQ'
                                    + '&r0='}${routeList.join(',')
      }`
      return next(data.response.route[0].summary, mapUrl)
    })
  return null
}

export function workingTimes() {
  const today = new Date()
  const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 8, 0, 0)
  const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 17, 0, 0)
  return [start, end]
}

export function replaceBetween(string, withTxt) {
  string.replace(/<.*>/, withTxt)
  return string
}
/*
* calculates the total price for loads/trucks with per/km price type if there is a destination defined to find distance
* */
export const getTotalPrice = (transaction, priceType, priceAgreed) => {
  if (!transaction || !transaction.distanceInKms || (priceType === PriceType.fixed && priceAgreed !== undefined)) {
    return false
  }
  const distanceInKms = (transaction.distanceInKms / 1000).toString()
  const kms = parseInt(distanceInKms, 10)
  const emptyKms = (transaction.emptyKms / 1000).toString()
  const emptyKm = parseInt(emptyKms, 10)
  return (kms * priceAgreed) + (emptyKm * priceAgreed)
}

export const gCurrency = (value, noDecimal = false) => {
  const val = !value || Number.isNaN(value) ? '-' : new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(value)
  return value > 50 || noDecimal ? val.replace(/\D00(?=\D*$)/, '') : val
}

export const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text)
}

export const copyToClipboardAsTable = (headers: string[], copyArray: any[], headersTranslations: string[]) => {
  const headerRow = headersTranslations.join('\t')
  const rows = copyArray.map(x => {
    let _r = ''
    x?.items.forEach((item) => {
      headers.forEach(y => {
        if (item[y]) {
          _r += `${item[y]}\t`
        }
      })
      _r += '\n'
    })
    return _r
  })
  // Combine the header and the rows
  const textToCopy = [headerRow, ...rows].join('\n')
  copyToClipboard(textToCopy)
}

interface LoadJsType {
  url: string;
  identifier: string;
  callback?: () => void;
}
export const loadJs = (params: LoadJsType) => {
  const script = document.querySelector(`script[data-set="${params.identifier}"]`)
  if (script) {
    return false
  }
  const newScript = document.createElement('script')
  newScript.setAttribute('src', params.url)
  newScript.setAttribute('data-set', params.identifier)
  if (params.callback) {
    newScript.onload = params.callback
  }
  return document.head.appendChild(newScript)
}

export const loadGoogleMapsJs = async (url: string, callback: () => void, identifier: string) => {
  const loadJsParams: LoadJsType = {
    url,
    identifier,
    callback
  }
  return loadJs(loadJsParams)
}

export const translateSelectItems = (items, labelKey, valueKey) => ([...(items || []).map((item) => ({
  label: item[`${labelKey}`],
  value: item[`${valueKey}`]
}))])

export const ceilDecimals = (value) => {
  if (value > 0) {
    return Math.ceil(value * 100) / 100
  }
  return Math.floor(value * 100) / 100
}

export const roundDecimals = (value) => Math.round(value * 100) / 100

export const percentageMinMax = (values, min, max) => {
  const {
    formattedValue,
    floatValue
  } = values
  if (floatValue == null) {
    return formattedValue === ''
  }
  return (floatValue <= max && floatValue >= min)
}

export const clearInput = (onSet, inputValue, setInputValue = (d) => null) => {
  if (onSet) {
    if (isString(inputValue)) {
      onSet('')
      setInputValue('')
    } else if (isNumber(inputValue) || isObject(inputValue)) {
      onSet(undefined)
      setInputValue(undefined)
    } else if (isArray(inputValue)) {
      onSet(undefined)
      setInputValue([])
    }
  }
}

export function reverseObject(obj) {
  const _obj = {}
  const reversedObj = Object.keys(obj).reverse()
  reversedObj.forEach(x => {
    _obj[x] = obj[x]
  })
  return _obj
}

export const lowerLabels = (obj) => map(obj, x => ({ label: x.label.toLocaleLowerCase, value: x.value }))

export const capitalizeFirst = (label) => (label && label.length > 1 ? label[0].toUpperCase() + label.slice(1).toLowerCase() : '')

export const adjustScroll = (value, elId) => {
  const el = document.getElementById(elId)
  if (el) {
    el.scrollLeft = value.scrollLeft
  }
}

export function deepEqual(obj1, obj2) {
  if (obj1 === obj2) {
    return true
  }
  if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
    return false
  }
  const keys1 = Object.keys(obj1)
  const keys2 = Object.keys(obj2)
  if (keys1.length !== keys2.length) {
    return false
  }
  for (const key of keys1) {
    if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
      return false
    }
  }
  return true
}

export function objectToQueryString(obj, keysNotIncluded = []) {
  const queryString = []
  for (const key in obj) {
    if (obj[key] && !keysNotIncluded.includes(key)) {
      queryString.push(`${encodeURIComponent(key)}=${encodeURIComponent(typeof obj[key] === 'object' ? JSON.stringify(obj[key]) : obj[key])}`)
    }
  }
  return queryString.join('&')
}

export function parseValue(value) {
  try {
    // Try parsing the value as a JSON string
    const parsedObject = JSON.parse(value)

    // Check if the parsed result is an object
    if (typeof parsedObject === 'object' && parsedObject !== null) {
      return parsedObject
    }
    // If it's not an object, return the parsed result as is (could be a string or other type)
    return parsedObject
  } catch (error) {
    // If parsing as JSON fails, return the original value as a string
    return value
  }
}

/*
* Counts the objects entries that are not false
* */
export function countNonFalseEntries(obj) {
  let count = 0

  for (const key in obj) {
    const value = obj[key]
    if (value !== false) {
      if (typeof value === 'object' && value !== null) {
        count += countNonFalseEntries(value)
      } else {
        count++
      }
    }
  }
  return count
}

/*
* Checks whether the given object contains all the keys given in keysArray
* Used to check whether all mandatory fields have been given a value
* */
export function objectHasKeys(object, keysArray) {
  for (const key of keysArray) {
    if (Array.isArray(object)) {
      for (const item of object) {
        if (typeof item === 'object' && !objectHasKeys(item, keysArray)) {
          return false
        }
      }
    } else if (!object[key] || object[key] === 'false') {
      return false
    }

    const value = object[key]

    if (Array.isArray(value)) {
      for (const item of value) {
        if (typeof item === 'object' && !objectHasKeys(item, keysArray)) {
          return false
        }
      }
    }
  }

  return true
}

export function sortArrayOfObjectsByOrder(arrayOfObjects, desiredOrder) {
  return arrayOfObjects.sort((a, b) => {
    let orderA = desiredOrder.indexOf(a.documentType)
    let orderB = desiredOrder.indexOf(b.documentType)

    if (orderA === -1) {
      orderA = desiredOrder.length
    }
    if (orderB === -1) {
      orderB = desiredOrder.length
    }

    return orderA - orderB
  })
}

export function getCountryCodeFromNIF(nif) {
  return nif.substring(0, 2)
}

export function getNIFFromNIF(nif) {
  return nif?.substring(2)
}
